/**
 * store/user/index.js
 *
 * Actions for the store's user object.
 *
 */


/**
 * sets the user object to the payload
 *
 * @param state
 * @param payload
 * @returns {{user: *}}
 */
export const set = (state, { payload }) => ({
    ...state,
    user: payload,
});

/**
 * clears the user object.
 *
 * @param state
 * @returns {{user: {}}}
 */
export const clear = (state) => ({
    ...state,
    user: {},
})
